import { jsx as _jsx } from "react/jsx-runtime";
import * as LabelPrimitive from "@radix-ui/react-label";
import cx from "classnames";
import cn from "variant-classnames";
import { toolkitCx } from "../../../constants";
const variants = {
    $all: "",
    size: {
        "2xs": "text-xxs",
        xs: "text-xs",
        sm: "text-sm",
        base: "text-base",
        lg: "text-lg",
        xl: "text-xl",
        "2xl": "text-2xl",
        "3xl": "text-3xl",
        "4xl": "text-4xl",
        "5xl": "text-5xl",
        "6xl": "text-6xl",
        "7xl": "text-7xl",
    },
};
/**
 * Label component is used to visually associate a label with an input element.
 *
 * @param {ILabelProps} props - The props of the component.
 * @param {React.ReactNode} props.children - The children of the component.
 * @param {string} props.className - The class name of the component.
 * @param {ITextProps["size"]} props.size - The size of the text.
 * @returns {React.ReactElement} - The Label component.
 */
const Label = ({ children, className, size, ...labelRootProps }) => {
    const textVariantCn = cn(variants, {
        className,
        size,
    });
    return (_jsx(LabelPrimitive.Root, { ...labelRootProps, className: cx(textVariantCn, toolkitCx.layout.text.default, toolkitCx.layout.transition.colors, className), children: children }));
};
export default Label;
//# sourceMappingURL=Label.js.map